/**
 * Sayfa başlığı (<title>) — TEK KAYNAK uzunluk kuralı.
 *
 * 2026-09-30 denetimi: 438 public sayfanın 56'sında başlık 70 karakteri aşıyordu (en uzun 90); Google uzun
 * başlığı kesip "…" ile gösterir. Fazlalığın kaynağı çoğunlukla sondaki marka eki (" | Riskmatik", 12 kr.) —
 * Google site adını arama sonucunda zaten ayrıca gösterir.
 * Kural: başlık `max`'ı aşıyorsa sondaki marka eki düşer; sığıyorsa eklenmiş haliyle kalır.
 * (Ek düşse de uzun kalan başlık veride kısaltılmalı — metni burada kırpmayız, anlam bozulur.)
 */
const MARKA_EKI = /\s*[|·—–-]\s*Riskmatik\s*$/;

export function sayfaBasligi(baslik: string, max = 70): string {
  const t = baslik.replace(/\s+/g, ' ').trim();
  return t.length <= max ? t : t.replace(MARKA_EKI, '');
}
